export interface SwipeConfig {
  threshold: number;
  routes: string[];
}

export function createSwipeHandler(
  config: SwipeConfig,
  navigate: (route: string) => void,
) {
  let startX = 0;
  let startY = 0;

  const onTouchStart = (e: TouchEvent) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  };

  const onTouchEnd = (e: TouchEvent) => {
    const dx = e.changedTouches[0].clientX - startX;
    const dy = e.changedTouches[0].clientY - startY;

    if (Math.abs(dx) < config.threshold || Math.abs(dy) > Math.abs(dx)) return;

    const hash = window.location.hash || "#/";
    const currentIndex = config.routes.indexOf(hash);
    if (currentIndex < 0) return;

    if (dx < 0 && currentIndex < config.routes.length - 1) {
      navigate(config.routes[currentIndex + 1]);
    } else if (dx > 0 && currentIndex > 0) {
      navigate(config.routes[currentIndex - 1]);
    }
  };

  return { onTouchStart, onTouchEnd };
}
